var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback } from "react";
import { API, Endpoints, LikeAPI, LikeObject, LikeStatisticsAPI } from "@brg/api";
import { useDispatch } from "react-redux";
import { useAuth, useFingerprintId, useProfile } from "@brg/auth";
import { useModal } from "../../../../core/modules/modal.module";
import { COMMENT_EDIT_MODE } from "../const/const";
import useLocalization from "../../../../hooks/useLocalization";
export var useGetCommentsHandlers = function (onUpdateData) {
    var dispatch = useDispatch();
    var modal = useModal();
    var profile = useProfile();
    var auth = useAuth();
    var i18n = useLocalization().i18n;
    var fingerprintId = useFingerprintId();
    var onDelete = useCallback(function (id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, API.request()
                        .endpoint(Endpoints.message)
                        .url('/api/comment/Delete')
                        .addQuery('id', id)
                        .post()
                        .send()
                        .then(function (r) { return r; })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); }, []);
    var onReport = useCallback(function (id) {
        modal.show('report', {
            entityId: id,
            entityType: "comment",
            handleClose: function () {
                modal.hide();
            }
        });
    }, [modal]);
    var onEdit = useCallback(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, API.request()
                        .endpoint(Endpoints.message)
                        .url("/api/comment/Edit")
                        .body(data)
                        .post()
                        .send()
                        .then(function (r) { return r; })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); }, []);
    var onAdd = useCallback(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, API.request()
                        .endpoint(Endpoints.message)
                        .url("/api/comment/Add")
                        .body(data)
                        .post()
                        .send()
                        .then(function (r) { return r; })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); }, []);
    var onGetLike = useCallback(function (_a) {
        var entityId = _a.entityId, entityType = _a.entityType;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(fingerprintId && entityId && entityType)) return [3 /*break*/, 2];
                        return [4 /*yield*/, LikeStatisticsAPI.GetLikeStatistics({ entityId: entityId, entityType: entityType })
                                .then(function (v) { return v.json(); })
                                .then(function (response) {
                                return response;
                            })
                                .catch(function (reason) {
                                console.error(reason);
                            })];
                    case 1: return [2 /*return*/, _b.sent()];
                    case 2: return [2 /*return*/];
                }
            });
        });
    }, [fingerprintId]);
    var onLike = useCallback(function (_a) {
        var entityId = _a.entityId, entityType = _a.entityType;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(fingerprintId && entityId && entityType)) return [3 /*break*/, 2];
                        return [4 /*yield*/, LikeAPI.LikeV2({ entityId: entityId, entityType: entityType })
                                .then(function (value) { return value.json(); })
                                .then(function (v) { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    if (v) {
                                        return [2 /*return*/, v];
                                    }
                                    throw new Error;
                                });
                            }); })];
                    case 1: return [2 /*return*/, _b.sent()];
                    case 2:
                        auth.login();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    }, [fingerprintId]);
    return {
        onReport: onReport,
        onDelete: onDelete,
        onEdit: onEdit,
        onAdd: onAdd,
        onLike: onLike,
        onGetLike: onGetLike
    };
};
//# sourceMappingURL=CommentHandlers.js.mapvar __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback } from "react";
import { API, Endpoints, LikeAPI, LikeObject, LikeStatisticsAPI } from "@brg/api";
import { useDispatch } from "react-redux";
import { useAuth, useFingerprintId, useProfile } from "@brg/auth";
import { useModal } from "../../../../core/modules/modal.module";
import { COMMENT_EDIT_MODE } from "../const/const";
import useLocalization from "../../../../hooks/useLocalization";
export var useGetCommentsHandlers = function (onUpdateData) {
    var dispatch = useDispatch();
    var modal = useModal();
    var profile = useProfile();
    var auth = useAuth();
    var i18n = useLocalization().i18n;
    var fingerprintId = useFingerprintId();
    var onDelete = useCallback(function (id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, API.request()
                        .endpoint(Endpoints.message)
                        .url('/api/comment/Delete')
                        .addQuery('id', id)
                        .post()
                        .send()
                        .then(function (r) { return r; })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); }, []);
    var onReport = useCallback(function (id) {
        modal.show('report', {
            entityId: id,
            entityType: "comment",
            handleClose: function () {
                modal.hide();
            }
        });
    }, [modal]);
    var onEdit = useCallback(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, API.request()
                        .endpoint(Endpoints.message)
                        .url("/api/comment/Edit")
                        .body(data)
                        .post()
                        .send()
                        .then(function (r) { return r; })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); }, []);
    var onAdd = useCallback(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, API.request()
                        .endpoint(Endpoints.message)
                        .url("/api/comment/Add")
                        .body(data)
                        .post()
                        .send()
                        .then(function (r) { return r; })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); }, []);
    var onGetLike = useCallback(function (_a) {
        var entityId = _a.entityId, entityType = _a.entityType;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(fingerprintId && entityId && entityType)) return [3 /*break*/, 2];
                        return [4 /*yield*/, LikeStatisticsAPI.GetLikeStatistics({ entityId: entityId, entityType: entityType })
                                .then(function (v) { return v.json(); })
                                .then(function (response) {
                                return response;
                            })
                                .catch(function (reason) {
                                console.error(reason);
                            })];
                    case 1: return [2 /*return*/, _b.sent()];
                    case 2: return [2 /*return*/];
                }
            });
        });
    }, [fingerprintId]);
    var onLike = useCallback(function (_a) {
        var entityId = _a.entityId, entityType = _a.entityType;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(fingerprintId && entityId && entityType)) return [3 /*break*/, 2];
                        return [4 /*yield*/, LikeAPI.LikeV2({ entityId: entityId, entityType: entityType })
                                .then(function (value) { return value.json(); })
                                .then(function (v) { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    if (v) {
                                        return [2 /*return*/, v];
                                    }
                                    throw new Error;
                                });
                            }); })];
                    case 1: return [2 /*return*/, _b.sent()];
                    case 2:
                        auth.login();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    }, [fingerprintId]);
    return {
        onReport: onReport,
        onDelete: onDelete,
        onEdit: onEdit,
        onAdd: onAdd,
        onLike: onLike,
        onGetLike: onGetLike
    };
};
//# sourceMappingURL=CommentHandlers.js.map